import SupplierReport from "../Components/SupplierReport";
import DoctorReport from "../Components/DoctorReport";
import ItemReport from "../Components/ItemDetailReport";
import StockReport from "../Components/StockReport";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ProductWiseSales from "../Components/ProductWiseSales";
import MyDailySales from "../Components/MyDailySales";
import InventoryMonitoring from "../Components/InventoryMonitoring";
import InventoryAnalysis from "../Components/InventoryAnalysis";
import AllInvoicesAnalysis from "../Components/AllInvoicesAnalysis";


export const ReportModules = [
    {
        id: 3,
        name: 'Sales Report',
        component: ItemReport,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 4,
        name: 'Inventory Report',
        component: StockReport,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 2,
        name: 'Supplier Report',
        component: SupplierReport,
        icon: <ArticleOutlinedIcon />
    },
    // {
    //     id: 5,
    //     name: 'Product Wise Sales Report',
    //     component: ProductWiseSales,
    //     icon: <ArticleOutlinedIcon />
    // },
    {
        id: 6,
        name: 'My Daily Sales',
        component: MyDailySales,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 7,
        name: 'Inventory Monitoring',
        component: InventoryMonitoring,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 8,
        name: 'Inventory Analysis',
        component: InventoryAnalysis,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 9,
        name: 'All Invoices Analysis',
        component: AllInvoicesAnalysis,
        icon: <ArticleOutlinedIcon />
    },

]
